import { useLocation } from 'react-router-dom';

import { UserModal } from '~/components/ui/UserModal/UserModal';
import { useNavigate } from '~/router';

export default function UserProfileModal() {
  const navigate = useNavigate();
  const location = useLocation();

  if (!location.state?.userId) return null;
  return <UserModal userId={location.state?.userId} onClose={() => navigate(-1)} />;
}
